// ============================================================================
// POLISH TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Zabawne, ale refleksyjne pytania

export const funQuestions = [
  {
    question: "Gdyby Jezus miał telefon, kto byłby Jego pierwszym kontaktem?",
    emoji: "📱",
    theme: "relacja_boska"
  },
  {
    question: "Dlaczego Dawid nigdy nie zgubił swoich owiec?",
    emoji: "🐑", 
    theme: "pasterz"
  },
  {
    question: "Ile kosztuje miłość Boga?",
    emoji: "💰",
    theme: "łaska"
  },
  {
    question: "Jaka jest różnica między pokojem Bożym a drzemką?",
    emoji: "😴",
    theme: "pokój"
  },
  {
    question: "Dlaczego Słowo Boże nigdy nie rozładowuje baterii?",
    emoji: "🔋",
    theme: "słowo"
  },
  {
    question: "Gdyby Mojżesz miał GPS, czy błądziłby 40 lat na pustyni?",
    emoji: "🗺️",
    theme: "przewodnictwo"
  },
  {
    question: "Dlaczego aniołowie nigdy nie muszą uprawiać sportu?",
    emoji: "👼",
    theme: "doskonałość"
  },
  {
    question: "Co powiedziałby Salomon o współczesnych mediach społecznościowych?",
    emoji: "📱",
    theme: "mądrość"
  }
];

export default funQuestions;
